module.exports = __webpack_public_path__ + "img/Screws.080ea480.svg";